import { render, staticRenderFns } from "./FileRating.vue?vue&type=template&id=11380216"
import script from "./FileRating.vue?vue&type=script&lang=ts"
export * from "./FileRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports